var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('anosafra-multiselect',{attrs:{"label":"Ano Safra"},on:{"input":_vm.notifyChange,"search-change":_vm.loadCrops},model:{value:(_vm.crop),callback:function ($$v) {_vm.crop=$$v},expression:"crop"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }